module.exports = __webpack_public_path__ + "static/media/users.341ffbfc.svg";